import { ApiBoardSettingsResponse } from '../../../api/core/models';
import { MeasurementSystem } from '../../../model/enums/measurement-system';

export function apiBoardSettingsToMeasurementSystem(apiBoardSettings?: ApiBoardSettingsResponse): MeasurementSystem {
  if (!apiBoardSettings?.defaultMeasurementSystem) {
    return MeasurementSystem.Metric;
  }
  if (apiBoardSettings.defaultMeasurementSystem === 'IMPERIAL') {
    return MeasurementSystem.USCustomaryUnits;
  }
  return MeasurementSystem.Metric;
}
